module.exports = __webpack_public_path__ + "img/diangugushi@3x.c101aca3.png";